
import { Mission } from '../../types';

export const MISSION_POOL: Mission[] = [
  {
    id: 'mission_tokyo_collab',
    title: 'Tokyo Collab Stage',
    description: "Jinu arranged a surprise collab. Rumi is suspicious, but Zoey is just excited to eat convenience store food.",
    origin: 'JINU',
    destination: 'TOKYO',
    reward: 5000000,
    fanReward: 250000,
    type: 'TOUR_DATE',
    buttonDescriptor: 'Visit Convenience Store'
  },
  {
    id: 'mission_la_endorsement',
    title: 'LA Streetwear Brand',
    description: "Zoey wants to go to Burbank because she thinks it's a mystical land. Might as well sign a deal while we're there.",
    origin: 'JINU',
    destination: 'LOS_ANGELES',
    reward: 1200000000,
    fanReward: 15000000,
    type: 'ENDORSEMENT',
    buttonDescriptor: 'Sign Endorsement Deal'
  },
  {
    id: 'mission_ny_crisis',
    title: 'New York Crisis',
    description: "Demonic energy spiking. Mira is annoyed because she hasn't finished her ramyun yet.",
    origin: 'JINU',
    destination: 'NEW_YORK',
    reward: 8000000,
    fanReward: 500000,
    type: 'TOUR_DATE',
    buttonDescriptor: 'Start Tour Date'
  },
  {
    id: 'mission_seoul_secret',
    title: 'Secret Fan Meet',
    description: "Jinu wants to meet. Rumi says 'Ew'. Sussie the bird is staring at us. Let's just do the fan meet.",
    origin: 'JINU',
    destination: 'SEOUL',
    reward: 2500000,
    fanReward: 300000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_london_underground',
    title: 'London Underground Gig',
    description: "Jinu booked a gig in a tube station. It's 'dark and cool'. Mira approves.",
    origin: 'JINU',
    destination: 'LONDON',
    reward: 15000000,
    fanReward: 400000,
    type: 'TOUR_DATE',
    buttonDescriptor: 'Start Tour Date'
  },
  {
    id: 'mission_street_food_tour',
    title: 'Global Street Food Tour',
    description: "Rumi heard about legendary street food spots across Asia. Time for a culinary adventure! The fans will love this content.",
    origin: 'FANS',
    destination: 'SEOUL',
    reward: 3000000,
    fanReward: 750000,
    type: 'COLLAB',
    buttonDescriptor: 'Start Global Food Tour'
  },
  {
    id: 'mission_tteokbokki_championship',
    title: 'Tteokbokki Eating Championship',
    description: "Zoey found a tteokbokki eating contest. She claims she's been training for this her whole life. Prize money and fame await!",
    origin: 'FANS',
    destination: 'SEOUL',
    reward: 1500000,
    fanReward: 500000,
    type: 'COLLAB',
    buttonDescriptor: 'Join Tteokbokki Contest'
  },
  {
    id: 'mission_midnight_snack_run',
    title: 'Midnight Snack Content',
    description: "Mira wants to film a midnight street food adventure. 'It's for the content' she says, while already drooling.",
    origin: 'FANS',
    destination: 'TOKYO',
    reward: 2000000,
    fanReward: 600000,
    type: 'ENDORSEMENT',
    buttonDescriptor: 'Go for Midnight Snacks'
  },
  {
    id: 'mission_spicy_noodle_challenge',
    title: 'Spicy Noodle Challenge Tour',
    description: "The entire group wants to travel to different cities to take on spicy noodle challenges. What could go wrong?",
    origin: 'JINU',
    destination: 'BEIJING',
    reward: 4000000,
    fanReward: 800000,
    type: 'TOUR_DATE',
    buttonDescriptor: 'Accept Noodle Challenge'
  },
  {
    id: 'mission_myeongdong_food_adventure',
    title: 'Myeongdong Street Food Tour',
    description: "The girls want to explore Myeongdong's famous street food scene. Corn dogs, bunggeoppang, and tteokbokki await! 'For the content' they insist.",
    origin: 'FANS',
    destination: 'SEOUL',
    reward: 2500000,
    fanReward: 600000,
    type: 'COLLAB',
    buttonDescriptor: 'Explore Myeongdong'
  },
  {
    id: 'mission_convenience_store_dining',
    title: 'GS25 Convenience Store Dining',
    description: "Mira discovered the art of Korean convenience store dining. Time to film content featuring shrimp chips, banana milk, and instant ramen!",
    origin: 'FANS',
    destination: 'SEOUL',
    reward: 1800000,
    fanReward: 450000,
    type: 'ENDORSEMENT',
    buttonDescriptor: 'Visit GS25'
  },
  {
    id: 'mission_seolleongtang_comfort',
    title: 'Seolleongtang Comfort Food Session',
    description: "After a tough battle, the girls need comforting beef bone soup. Rumi insists this is traditional demon-hunting recovery food.",
    origin: 'JINU',
    destination: 'SEOUL',
    reward: 3200000,
    fanReward: 700000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_gimbap_plane_snack',
    title: 'Private Plane Gimbap Party',
    description: "The girls need grab-and-go kimbap for their world tour. 'We can't seal the honmoon on an empty stomach!' Zoey declares.",
    origin: 'JINU',
    destination: 'TOKYO',
    reward: 2800000,
    fanReward: 550000,
    type: 'TOUR_DATE',
    buttonDescriptor: 'Try Gimbap'
  },
  {
    id: 'mission_chinese_demon_hunt',
    title: 'Jiangshi Terror in Shanghai',
    description: "Chinese hopping vampires (Jiangshi) are terrorizing the Bund. Time to show them some K-pop demon-hunting moves!",
    origin: 'JINU',
    destination: 'SHANGHAI',
    reward: 15000000,
    fanReward: 2000000,
    type: 'TOUR_DATE',
    buttonDescriptor: 'Start Tour Date'
  },
  {
    id: 'mission_brazilian_curupira',
    title: 'Curupira in the Amazon',
    description: "The Brazilian demon Curupira with backward feet is causing chaos in Rio. 'Is he dancing or running?' Zoey asks.",
    origin: 'JINU',
    destination: 'RIO_DE_JANEIRO',
    reward: 12000000,
    fanReward: 1800000,
    type: 'TOUR_DATE',
    buttonDescriptor: 'Start Tour Date'
  },
  {
    id: 'mission_mexican_llorona',
    title: 'La Llorona Weeping Concert',
    description: "La Llorona's ghostly voice is disrupting Mexico City performances. Rumi says 'She needs vocal lessons, not haunting.'",
    origin: 'JINU',
    destination: 'MEXICO_CITY',
    reward: 13000000,
    fanReward: 1900000,
    type: 'TOUR_DATE',
    buttonDescriptor: 'Start Tour Date'
  },
  {
    id: 'mission_sao_paulo_saci',
    title: 'Saci-Pererê Mischief',
    description: "The one-legged Brazilian trickster demon Saci is causing chaos in São Paulo. 'He stole my stage props!' Mira complains.",
    origin: 'FANS',
    destination: 'SAO_PAULO',
    reward: 8000000,
    fanReward: 1200000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_mumbai_rakshasa',
    title: 'Bollywood Rakshasa Battle',
    description: "Rakshasa demons are disrupting Mumbai's film industry. 'They think they can out-dance us? Please!' Rumi scoffs.",
    origin: 'JINU',
    destination: 'MUMBAI',
    reward: 14000000,
    fanReward: 2100000,
    type: 'ENDORSEMENT',
    buttonDescriptor: 'Sign Endorsement Deal'
  },
  {
    id: 'mission_cairo_ghoul',
    title: 'Cairo Desert Ghoul Encounter',
    description: "Ancient Egyptian ghouls are haunting the pyramids. 'They need to update their haunting style. So last millennium.' Zoey declares.",
    origin: 'JINU',
    destination: 'CAIRO',
    reward: 16000000,
    fanReward: 2300000,
    type: 'TOUR_DATE',
    buttonDescriptor: 'Start Tour Date'
  },
  {
    id: 'mission_bigfoot_sighting',
    title: 'Bigfoot Concert Crash',
    description: "Bigfoot is trying to crash a concert in Los Angeles. 'Is he a demon? I don't know. I don't care. We're fighting him.' Zoey insists.",
    origin: 'FANS',
    destination: 'LOS_ANGELES',
    reward: 9000000,
    fanReward: 1300000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_kappa_sumo',
    title: 'Kappa River Challenge',
    description: "Japanese water demons Kappa are challenging idols to sumo wrestling in Tokyo. 'They want our heads? Not today!' Mira vows.",
    origin: 'JINU',
    destination: 'TOKYO',
    reward: 7000000,
    fanReward: 1100000,
    type: 'TOUR_DATE',
    buttonDescriptor: 'Start Tour Date'
  },
  {
    id: 'mission_dragon_dance',
    title: 'Chinese Dragon Demon Festival',
    description: "A malevolent dragon demon is disrupting the Spring Festival in Beijing. 'Nobody ruins our food festival!' Mira declares.",
    origin: 'FANS',
    destination: 'BEIJING',
    reward: 11000000,
    fanReward: 1700000,
    type: 'COLLAB',
    buttonDescriptor: 'Try Festival Food'
  },
  {
    id: 'mission_brazilian_carnival',
    title: 'Carnival Demon Invasion',
    description: "Demons are trying to ruin Rio's Carnival. 'Nobody messes with our samba!' the girls declare, ready to fight and dance.",
    origin: 'JINU',
    destination: 'RIO_DE_JANEIRO',
    reward: 13500000,
    fanReward: 2000000,
    type: 'ENDORSEMENT',
    buttonDescriptor: 'Sign Endorsement Deal'
  },
  {
    id: 'mission_day_of_dead',
    title: 'Día de los Muertos Demon',
    description: "A demon is disrupting Mexico City's Day of the Dead celebrations. 'They clearly don't understand family traditions.' Rumi says.",
    origin: 'FANS',
    destination: 'MEXICO_CITY',
    reward: 10000000,
    fanReward: 1500000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_london_underground_banshee',
    title: 'London Underground Banshee',
    description: "A banshee's wail is disrupting the tube system. 'She thinks she can out-sing us? Not a chance!' Zoey declares.",
    origin: 'JINU',
    destination: 'LONDON',
    reward: 8500000,
    fanReward: 1200000,
    type: 'TOUR_DATE',
    buttonDescriptor: 'Start Tour Date'
  },
  {
    id: 'mission_paris_gargoyle_invasion',
    title: 'Notre Dame Gargoyle Attack',
    description: "Stone gargoyles have come to life in Paris. 'They need better skincare routines. All that stone can't be good.' Mira critiques.",
    origin: 'JINU',
    destination: 'PARIS',
    reward: 9500000,
    fanReward: 1400000,
    type: 'ENDORSEMENT',
    buttonDescriptor: 'Sign Endorsement Deal'
  },
  {
    id: 'mission_new_york_wendigo',
    title: 'Central Park Wendigo',
    description: "A Wendigo is haunting Central Park. 'Nobody ruins our NYC street food adventures!' Mira vows.",
    origin: 'FANS',
    destination: 'NEW_YORK',
    reward: 7500000,
    fanReward: 1100000,
    type: 'COLLAB',
    buttonDescriptor: 'Try NYC Street Food'
  },
  {
    id: 'mission_beijing_huli_jing',
    title: 'Forbidden City Fox Spirits',
    description: "Chinese fox spirits (Huli Jing) are causing mischief in Beijing. 'They think they're sly? We invented sly!' Rumi scoffs.",
    origin: 'JINU',
    destination: 'BEIJING',
    reward: 8000000,
    fanReward: 1300000,
    type: 'TOUR_DATE',
    buttonDescriptor: 'Try Beijing Street Food'
  },
  {
    id: 'mission_seoul_dokkaebi',
    title: 'Seoul Dokkaebi Tricksters',
    description: "Korean goblin demons Dokkaebi are playing tricks in Seoul. 'They want to challenge us to games? Bring it on!' Rumi accepts.",
    origin: 'FANS',
    destination: 'SEOUL',
    reward: 6000000,
    fanReward: 900000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_tokyo_oni',
    title: 'Tokyo Oni Rampage',
    description: "Japanese Oni demons are disrupting Shibuya. 'Those clubs are ours! Nobody ruins our party time!' Zoey declares.",
    origin: 'JINU',
    destination: 'TOKYO',
    reward: 7000000,
    fanReward: 1000000,
    type: 'TOUR_DATE',
    buttonDescriptor: 'Start Tour Date'
  },
  {
    id: 'mission_la_chupacabra',
    title: 'Hollywood Chupacabra',
    description: "A Chupacabra is targeting celebrity pets in LA. 'Nobody messes with our furry friends!' the girls defend.",
    origin: 'FANS',
    destination: 'LOS_ANGELES',
    reward: 6500000,
    fanReward: 950000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_sydney_dropbear',
    title: 'Sydney Drop Bear Attack',
    description: "Deadly drop bears are terrorizing tourists at the Opera House. 'They think they can drop on us? We invented stage diving!' Zoey boasts.",
    origin: 'JINU',
    destination: 'SYDNEY',
    reward: 17000000,
    fanReward: 2400000,
    type: 'TOUR_DATE',
    buttonDescriptor: 'Start Tour Date'
  },
  {
    id: 'mission_melbourne_bunyip',
    title: 'Melbourne Bunyip in the Yarra',
    description: "The ancient Bunyip monster is haunting Melbourne's Yarra River. 'Nobody ruins our coffee culture!' Mira defends.",
    origin: 'JINU',
    destination: 'MELBOURNE',
    reward: 18000000,
    fanReward: 2500000,
    type: 'ENDORSEMENT',
    buttonDescriptor: 'Sign Endorsement Deal'
  },
  {
    id: 'mission_sydney_rainbow_serpent',
    title: 'Rainbow Serpent Dreamtime',
    description: "The Rainbow Serpent is disrupting a Dreamtime festival in Sydney. 'They need to respect the land and our tour schedule!' Rumi insists.",
    origin: 'FANS',
    destination: 'SYDNEY',
    reward: 14000000,
    fanReward: 2000000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_melbourne_yowie',
    title: 'Yowie in the Outback',
    description: "Australian Bigfoot-like Yowie creatures are causing chaos near Melbourne. 'Is he like Bigfoot? I don't know. I don't care. We're fighting him too!' Zoey declares.",
    origin: 'JINU',
    destination: 'MELBOURNE',
    reward: 15000000,
    fanReward: 2100000,
    type: 'TOUR_DATE',
    buttonDescriptor: 'Start Tour Date'
  },
  {
    id: 'mission_sydney_terror_australis',
    title: 'Sydney Terror Australis',
    description: "The giant extinct marsupial lion Terror Australis has been resurrected by dark magic. 'They brought back what? This is why we can't have nice things!' Mira complains.",
    origin: 'FANS',
    destination: 'SYDNEY',
    reward: 20000000,
    fanReward: 2800000,
    type: 'ENDORSEMENT',
    buttonDescriptor: 'Sign Endorsement Deal'
  },
  {
    id: 'mission_buenos_aires_mapinguari',
    title: 'Buenos Aires Mapinguari Attack',
    description: "The giant Mapinguari monster is terrorizing Buenos Aires. 'They think they can stomp through our tango district? Not on our watch!' Rumi declares.",
    origin: 'JINU',
    destination: 'BUENOS_AIRES',
    reward: 21000000,
    fanReward: 2900000,
    type: 'TOUR_DATE',
    buttonDescriptor: 'Start Tour Date'
  },
  {
    id: 'mission_lima_pishtaco',
    title: 'Lima Pishtaco Menace',
    description: "The vampire-like Pishtaco is haunting Lima's streets. 'Nobody messes with our ceviche dates!' Zoey defends.",
    origin: 'JINU',
    destination: 'LIMA',
    reward: 22000000,
    fanReward: 3000000,
    type: 'ENDORSEMENT',
    buttonDescriptor: 'Sign Endorsement Deal'
  },
  {
    id: 'mission_bogota_mohan',
    title: 'Bogotá Mohan River Demon',
    description: "The Mohan river demon is disrupting Bogotá's music scene. 'They think they can out-party us? Never!' Rumi scoffs.",
    origin: 'FANS',
    destination: 'BOGOTA',
    reward: 19000000,
    fanReward: 2700000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_caracas_la_sayona',
    title: 'Caracas La Sayona Revenge',
    description: "The vengeful spirit La Sayona is haunting Caracas. 'She needs therapy, not haunting. We're calling our healer!' Mira insists.",
    origin: 'JINU',
    destination: 'CARACAS',
    reward: 20000000,
    fanReward: 2800000,
    type: 'TOUR_DATE',
    buttonDescriptor: 'Start Tour Date'
  },
  {
    id: 'mission_guatemala_cadejo',
    title: 'Guatemala City Cadejo Brothers',
    description: "The dual Cadejo dog spirits are causing chaos in Guatemala City. 'One good, one evil? We're taking down the evil one!' Mira vows.",
    origin: 'FANS',
    destination: 'GUATEMALA_CITY',
    reward: 16000000,
    fanReward: 2300000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_panama_chivato',
    title: 'Panama City Chivato Spirit',
    description: "The Chivato ghost is haunting Panama Canal. 'Nobody disrupts international shipping and our concert schedule!' Zoey declares.",
    origin: 'JINU',
    destination: 'PANAMA_CITY',
    reward: 17000000,
    fanReward: 2400000,
    type: 'ENDORSEMENT',
    buttonDescriptor: 'Sign Endorsement Deal'
  },
  {
    id: 'mission_moscow_baba_yaga',
    title: 'Moscow Baba Yaga Hut',
    description: "Baba Yaga's chicken-legged hut is stomping through Moscow. 'That hut has better dance moves than some idols!' Rumi jokes.",
    origin: 'JINU',
    destination: 'MOSCOW',
    reward: 23000000,
    fanReward: 3100000,
    type: 'TOUR_DATE',
    buttonDescriptor: 'Start Tour Date'
  },
  {
    id: 'mission_istanbul_jinn',
    title: 'Istanbul Jinn Invasion',
    description: "Middle Eastern Jinn are disrupting Istanbul's bazaars. 'They think they can out-bargain us? We invented deals!' Rumi boasts.",
    origin: 'FANS',
    destination: 'ISTANBUL',
    reward: 24000000,
    fanReward: 3200000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_dubai_ifrit',
    title: 'Dubai Ifrit Desert Attack',
    description: "Fire demons Ifrit are attacking Dubai's luxury district. 'Nobody ruins our shopping sprees!' the girls defend.",
    origin: 'JINU',
    destination: 'DUBAI',
    reward: 25000000,
    fanReward: 3300000,
    type: 'ENDORSEMENT',
    buttonDescriptor: 'Sign Endorsement Deal'
  },
  {
    id: 'mission_bangkok_phi',
    title: 'Bangkok Phi Ghost Haunting',
    description: "Thai Phi ghosts are haunting Bangkok's temples. 'They need to respect sacred spaces and our rehearsal time!' Mira says.",
    origin: 'FANS',
    destination: 'BANGKOK',
    reward: 18000000,
    fanReward: 2600000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_singapore_pontianak',
    title: 'Singapore Pontianak Vampire',
    description: "The Pontianak vampire is haunting Singapore's Gardens by the Bay. 'She thinks she can scare us? We've seen worse fan mail!' Zoey scoffs.",
    origin: 'JINU',
    destination: 'SINGAPORE',
    reward: 26000000,
    fanReward: 3400000,
    type: 'TOUR_DATE',
    buttonDescriptor: 'Start Tour Date'
  },
  {
    id: 'mission_jakarta_rangda',
    title: 'Jakarta Rangda Demon Queen',
    description: "The Rangda demon queen is terrorizing Jakarta. 'She thinks she's scary? Try dealing with antis!' Rumi retorts.",
    origin: 'FANS',
    destination: 'JAKARTA',
    reward: 27000000,
    fanReward: 3500000,
    type: 'ENDORSEMENT',
    buttonDescriptor: 'Sign Endorsement Deal'
  },
  {
    id: 'mission_manila_aswang',
    title: 'Manila Aswang Shapeshifters',
    description: "Filipino Aswang shapeshifters are causing chaos in Manila. 'They think they can out-perform us? Never!' Mira declares.",
    origin: 'JINU',
    destination: 'MANILA',
    reward: 28000000,
    fanReward: 3600000,
    type: 'TOUR_DATE',
    buttonDescriptor: 'Start Tour Date'
  },
  {
    id: 'mission_warsaw_leshy',
    title: 'Warsaw Leshy Forest Demon',
    description: "The Slavic Leshy forest demon is haunting Warsaw's parks. 'Nobody ruins our picnic dates!' Zoey defends.",
    origin: 'FANS',
    destination: 'WARSAW',
    reward: 19000000,
    fanReward: 2700000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_prague_golem',
    title: 'Prague Golem Rampage',
    description: "The Prague Golem has come to life and is disrupting the old town. 'He needs better choreography!' Mira critiques.",
    origin: 'JINU',
    destination: 'PRAGUE',
    reward: 20000000,
    fanReward: 2800000,
    type: 'ENDORSEMENT',
    buttonDescriptor: 'Sign Endorsement Deal'
  },
  {
    id: 'mission_auckland_patupaiarehe',
    title: 'Auckland Patupaiarehe Encounter',
    description: "The mist-dwelling Patupaiarehe fairy people are haunting Auckland's Sky Tower. 'They think they're ethereal? We invented ethereal!' Zoey declares.",
    origin: 'JINU',
    destination: 'AUCKLAND',
    reward: 29000000,
    fanReward: 3700000,
    type: 'TOUR_DATE',
    buttonDescriptor: 'Start Tour Date'
  },
  {
    id: 'mission_wellington_taniwha',
    title: 'Wellington Taniwha Harbor Attack',
    description: "The guardian Taniwha dragon is disrupting Wellington Harbor. 'Nobody messes with our ferry rides to concerts!' Rumi defends.",
    origin: 'FANS',
    destination: 'WELLINGTON',
    reward: 30000000,
    fanReward: 3800000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_auckland_maero',
    title: 'Auckland Maero Forest Demons',
    description: "The wild Maero forest demons with long fingernails are terrorizing Auckland's parks. 'They need manicures and better attitudes!' Mira critiques.",
    origin: 'JINU',
    destination: 'AUCKLAND',
    reward: 28000000,
    fanReward: 3600000,
    type: 'ENDORSEMENT',
    buttonDescriptor: 'Sign Endorsement Deal'
  },
  {
    id: 'mission_wellington_pouakai',
    title: 'Wellington Pouakai Giant Eagle',
    description: "The legendary Pouakai giant eagle is hunting near Wellington. 'They think they can fly? We have private jets!' Mira boasts.",
    origin: 'FANS',
    destination: 'WELLINGTON',
    reward: 27000000,
    fanReward: 3500000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_toronto_wendigo',
    title: 'Toronto Wendigo in the Woods',
    description: "A Wendigo is haunting Toronto's ravines. 'Nobody ruins our poutine dates!' Zoey defends.",
    origin: 'JINU',
    destination: 'TORONTO',
    reward: 8500000,
    fanReward: 1200000,
    type: 'TOUR_DATE',
    buttonDescriptor: 'Start Tour Date'
  },
  {
    id: 'mission_montreal_loup_garou',
    title: 'Montreal Loup-Garou Werewolves',
    description: "French-Canadian werewolves are terrorizing Montreal. 'They think they can howl? We have better vocal runs!' Rumi scoffs.",
    origin: 'FANS',
    destination: 'MONTREAL',
    reward: 9000000,
    fanReward: 1300000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_chicago_windigo',
    title: 'Chicago Windigo Industrial Attack',
    description: "The Windigo demon is haunting Chicago's factories. 'Nobody disrupts our deep-dish pizza nights!' Mira declares.",
    origin: 'JINU',
    destination: 'CHICAGO',
    reward: 8800000,
    fanReward: 1250000,
    type: 'ENDORSEMENT',
    buttonDescriptor: 'Sign Endorsement Deal'
  },
  {
    id: 'mission_miami_chupacabra',
    title: 'Miami Beach Chupacabra',
    description: "Chupacabras are targeting Miami Beach parties. 'Nobody ruins our beach photoshoots!' Mira defends.",
    origin: 'FANS',
    destination: 'MIAMI',
    reward: 9200000,
    fanReward: 1350000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_berlin_nachzehrer',
    title: 'Berlin Nachzehrer Ghouls',
    description: "German Nachzehrer ghouls are haunting Berlin's clubs. 'They think they can out-party us? Never!' Rumi scoffs.",
    origin: 'JINU',
    destination: 'BERLIN',
    reward: 11000000,
    fanReward: 1600000,
    type: 'TOUR_DATE',
    buttonDescriptor: 'Start Tour Date'
  },
  {
    id: 'mission_madrid_duende',
    title: 'Madrid Duende Mischief',
    description: "Spanish Duende sprites are causing chaos in Madrid. 'They need better dance moves!' Zoey critiques.",
    origin: 'FANS',
    destination: 'MADRID',
    reward: 11500000,
    fanReward: 1700000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_rome_lamia',
    title: 'Rome Lamia Vampire Queens',
    description: "Ancient Lamia vampire queens are haunting Rome's ruins. 'They think they're eternal? Our music is eternal!' Rumi declares.",
    origin: 'JINU',
    destination: 'ROME',
    reward: 12000000,
    fanReward: 1800000,
    type: 'ENDORSEMENT',
    buttonDescriptor: 'Sign Endorsement Deal'
  },
  {
    id: 'mission_stockholm_skracka',
    title: 'Stockholm Skräcka Sea Demons',
    description: "Swedish Skräcka sea demons are haunting the archipelago. 'Nobody disrupts our ferry concerts!' Mira vows.",
    origin: 'FANS',
    destination: 'STOCKHOLM',
    reward: 12500000,
    fanReward: 1900000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_helsinki_fiinnish',
    title: 'Helsinki Finnish Forest Spirits',
    description: "Finnish forest spirits are disrupting Helsinki. 'They need to respect sauna time!' Mira insists.",
    origin: 'JINU',
    destination: 'HELSINKI',
    reward: 13000000,
    fanReward: 2000000,
    type: 'TOUR_DATE',
    buttonDescriptor: 'Start Tour Date'
  },
  {
    id: 'mission_athens_vrykolakas',
    title: 'Athens Vrykolakas Vampires',
    description: "Greek Vrykolakas vampires are haunting the Acropolis. 'Nobody ruins our ancient ruins photoshoots!' Zoey defends.",
    origin: 'FANS',
    destination: 'ATHENS',
    reward: 13500000,
    fanReward: 2100000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_lisbon_bruxa',
    title: 'Lisbon Bruxa Witches',
    description: "Portuguese Bruxa witches are casting spells in Lisbon. 'They think they can hex us? We have anti-fan hexes!' Rumi boasts.",
    origin: 'JINU',
    destination: 'LISBON',
    reward: 14000000,
    fanReward: 2200000,
    type: 'ENDORSEMENT',
    buttonDescriptor: 'Sign Endorsement Deal'
  },
  {
    id: 'mission_osaka_oni',
    title: 'Osaka Oni Rampage',
    description: "Japanese Oni demons are disrupting Osaka's Dotonbori. 'Nobody ruins our street food tours!' Rumi defends.",
    origin: 'FANS',
    destination: 'OSAKA',
    reward: 7500000,
    fanReward: 1050000,
    type: 'COLLAB',
    buttonDescriptor: 'Start Food Tour'
  },
  {
    id: 'mission_hanoi_ma',
    title: 'Hanoi Ma Ghost Spirits',
    description: "Vietnamese Ma ghost spirits are haunting Hanoi's old quarter. 'They need to respect pho time!' Zoey declares.",
    origin: 'JINU',
    destination: 'HANOI',
    reward: 9500000,
    fanReward: 1400000,
    type: 'TOUR_DATE',
    buttonDescriptor: 'Start Tour Date'
  },
  {
    id: 'mission_ho_chi_minh_city_ma',
    title: 'Ho Chi Minh City Ma Da',
    description: "Vietnamese Ma Da forest demons are terrorizing the city. 'Nobody disrupts our coffee culture!' Mira insists.",
    origin: 'FANS',
    destination: 'HO_CHI_MINH_CITY',
    reward: 10000000,
    fanReward: 1500000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_lagos_eki',
    title: 'Lagos Eki Water Spirits',
    description: "Nigerian Eki water spirits are haunting Lagos lagoon. 'Nobody ruins our beach parties!' Mira defends.",
    origin: 'JINU',
    destination: 'LAGOS',
    reward: 16000000,
    fanReward: 2400000,
    type: 'ENDORSEMENT',
    buttonDescriptor: 'Sign Endorsement Deal'
  },
  {
    id: 'mission_johannesburg_tikoloshe',
    title: 'Johannesburg Tikoloshe Goblins',
    description: "South African Tikoloshe goblins are causing chaos in Johannesburg. 'They think they can sneak? We see everything!' Rumi scoffs.",
    origin: 'FANS',
    destination: 'JOHANNESBURG',
    reward: 17000000,
    fanReward: 2500000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_cape_town_berg',
    title: 'Cape Town Berg Wind Demons',
    description: "South African Berg wind demons are haunting Table Mountain. 'Nobody disrupts our mountain photoshoots!' Zoey vows.",
    origin: 'JINU',
    destination: 'CAPE_TOWN',
    reward: 18000000,
    fanReward: 2600000,
    type: 'TOUR_DATE',
    buttonDescriptor: 'Start Tour Date'
  },
  {
    id: 'mission_tehran_div',
    title: 'Tehran Div Demons',
    description: "Persian Div demons are haunting Tehran's mountains. 'They think they can out-sing us? Never!' Rumi scoffs.",
    origin: 'JINU',
    destination: 'TEHRAN',
    reward: 31000000,
    fanReward: 3900000,
    type: 'ENDORSEMENT',
    buttonDescriptor: 'Sign Endorsement Deal'
  },
  {
    id: 'mission_riyadh_ifrit',
    title: 'Riyadh Desert Ifrit',
    description: "Saudi Ifrit fire demons are attacking Riyadh. 'Nobody ruins our desert concerts!' Mira declares.",
    origin: 'FANS',
    destination: 'RIYADH',
    reward: 32000000,
    fanReward: 4000000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_baghdad_ghoul',
    title: 'Baghdad Ancient Ghouls',
    description: "Mesopotamian ghouls are haunting Baghdad's ancient sites. 'They need to respect history and our tour schedule!' Rumi insists.",
    origin: 'JINU',
    destination: 'BAGHDAD',
    reward: 33000000,
    fanReward: 4100000,
    type: 'TOUR_DATE',
    buttonDescriptor: 'Start Tour Date'
  },
  {
    id: 'mission_kuwait_city_djinn',
    title: 'Kuwait City Djinn',
    description: "Arabian Djinn are causing chaos in Kuwait City. 'They think they can grant wishes? We grant hits!' Zoey boasts.",
    origin: 'FANS',
    destination: 'KUWAIT_CITY',
    reward: 34000000,
    fanReward: 4200000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_doha_hinn',
    title: 'Doha Hinn Spirits',
    description: "Qatari Hinn spirits are haunting Doha's skyline. 'Nobody disrupts our luxury shopping!' Mira defends.",
    origin: 'JINU',
    destination: 'DOHA',
    reward: 35000000,
    fanReward: 4300000,
    type: 'ENDORSEMENT',
    buttonDescriptor: 'Sign Endorsement Deal'
  },
  {
    id: 'mission_manama_bahamut',
    title: 'Manama Bahamut Sea Dragon',
    description: "The Bahamut sea dragon is threatening Bahrain's coast. 'They think they're ancient? Our music is timeless!' Rumi declares.",
    origin: 'FANS',
    destination: 'MANAMA',
    reward: 36000000,
    fanReward: 4400000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_muscat_ghoul',
    title: 'Muscat Desert Ghouls',
    description: "Omani desert ghouls are haunting Muscat's souks. 'Nobody ruins our spice market tours!' Mira vows.",
    origin: 'JINU',
    destination: 'MUSCAT',
    reward: 37000000,
    fanReward: 4500000,
    type: 'TOUR_DATE',
    buttonDescriptor: 'Start Tour Date'
  },
  {
    id: 'mission_sana_nasnas',
    title: 'Sana Nasnas Demons',
    description: "Yemeni Nasnas half-human demons are terrorizing Sana. 'They need better dance moves!' Zoey critiques.",
    origin: 'FANS',
    destination: 'SANA',
    reward: 38000000,
    fanReward: 4600000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_kiev_vodyanoy',
    title: 'Kiev Vodyanoy Water Spirit',
    description: "Ukrainian Vodyanoy water spirits are haunting the Dnieper River. 'Nobody disrupts our river cruises!' Rumi defends.",
    origin: 'JINU',
    destination: 'KIEV',
    reward: 19000000,
    fanReward: 2700000,
    type: 'ENDORSEMENT',
    buttonDescriptor: 'Sign Endorsement Deal'
  },
  {
    id: 'mission_minsk_lisovyk',
    title: 'Minsk Lisovyk Forest Demon',
    description: "Belarusian Lisovyk forest demons are haunting Minsk's parks. 'Nobody ruins our nature walks!' Mira insists.",
    origin: 'FANS',
    destination: 'MINSK',
    reward: 18500000,
    fanReward: 2650000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_bucharest_strigoi',
    title: 'Bucharest Strigoi Vampires',
    description: "Romanian Strigoi vampires are haunting Bucharest. 'They think they're immortal? Our fame is eternal!' Rumi boasts.",
    origin: 'JINU',
    destination: 'BUCHAREST',
    reward: 19500000,
    fanReward: 2750000,
    type: 'TOUR_DATE',
    buttonDescriptor: 'Start Tour Date'
  },
  {
    id: 'mission_samodiva',
    title: 'Sofia Samodiva Wild Nymphs',
    description: "Bulgarian Samodiva wild nymphs are causing chaos in Sofia. 'They think they can enchant us? We have better magic!' Zoey scoffs.",
    origin: 'FANS',
    destination: 'SOFIA',
    reward: 20000000,
    fanReward: 2800000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_belgrade_drekavac',
    title: 'Belgrade Drekavac Screamer',
    description: "Serbian Drekavac screamers are haunting Belgrade. 'They think they can out-scream us? We have microphones!' Mira declares.",
    origin: 'JINU',
    destination: 'BELGRADE',
    reward: 20500000,
    fanReward: 2850000,
    type: 'ENDORSEMENT',
    buttonDescriptor: 'Sign Endorsement Deal'
  },
  {
    id: 'mission_budapest_lidérc',
    title: 'Budapest Lidérc Dream Demon',
    description: "Hungarian Lidérc dream demons are haunting Budapest. 'Nobody disrupts our beauty sleep!' Mira defends.",
    origin: 'FANS',
    destination: 'BUDAPEST',
    reward: 21000000,
    fanReward: 2900000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_vienna_nachzehrer',
    title: 'Vienna Nachzehrer Ghouls',
    description: "Austrian Nachzehrer ghouls are haunting Vienna's opera houses. 'They think they can out-perform us? Never!' Rumi scoffs.",
    origin: 'JINU',
    destination: 'VIENNA',
    reward: 21500000,
    fanReward: 2950000,
    type: 'TOUR_DATE',
    buttonDescriptor: 'Start Tour Date'
  },
  {
    id: 'mission_islamabad_pari',
    title: 'Islamabad Pari Fairies',
    description: "Pakistani Pari fairies are causing mischief in Islamabad. 'They think they can fly? We have private jets!' Rumi boasts.",
    origin: 'FANS',
    destination: 'ISLAMABAD',
    reward: 24000000,
    fanReward: 3300000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_karachi_jinn',
    title: 'Karachi Jinn Possession',
    description: "Pakistani Jinn are possessing people in Karachi. 'They need to respect our fan meetups!' Zoey insists.",
    origin: 'JINU',
    destination: 'KARACHI',
    reward: 23000000,
    fanReward: 3200000,
    type: 'ENDORSEMENT',
    buttonDescriptor: 'Sign Endorsement Deal'
  },
  {
    id: 'mission_delhi_rakshasa',
    title: 'Delhi Rakshasa Battle',
    description: "Indian Rakshasa demons are disrupting Delhi's concerts. 'They think they can shapeshift? We have costume changes!' Mira declares.",
    origin: 'FANS',
    destination: 'DELHI',
    reward: 22000000,
    fanReward: 3100000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_kathmandu_yeti',
    title: 'Kathmandu Yeti Encounter',
    description: "Nepalese Yeti are roaming Kathmandu's streets. 'Is he like Bigfoot? I don't know. I don't care. We're fighting him too!' Zoey declares.",
    origin: 'JINU',
    destination: 'KATHMANDU',
    reward: 22500000,
    fanReward: 3150000,
    type: 'TOUR_DATE',
    buttonDescriptor: 'Start Tour Date'
  },
  {
    id: 'mission_dhakka_bhoot',
    title: 'Dhaka Bhoot Ghosts',
    description: "Bangladeshi Bhoot ghosts are haunting Dhaka. 'They think they can scare us? We've seen worse antis!' Mira scoffs.",
    origin: 'FANS',
    destination: 'DHAKA',
    reward: 23500000,
    fanReward: 3250000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_yangon_nat',
    title: 'Yangon Nat Spirits',
    description: "Myanmar Nat spirits are disrupting Yangon's pagodas. 'They need to respect sacred spaces and our rehearsals!' Rumi insists.",
    origin: 'JINU',
    destination: 'YANGON',
    reward: 24500000,
    fanReward: 3350000,
    type: 'ENDORSEMENT',
    buttonDescriptor: 'Sign Endorsement Deal'
  },
  {
    id: 'mission_lhasa_mountain_spirits',
    title: 'Lhasa Mountain Spirits',
    description: "Tibetan mountain spirits are haunting Lhasa's monasteries. 'Nobody disrupts our spiritual retreats!' Zoey defends.",
    origin: 'FANS',
    destination: 'LHASA',
    reward: 39000000,
    fanReward: 4700000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_kabul_daeva',
    title: 'Kabul Daeva Demons',
    description: "Afghan Daeva demons are terrorizing Kabul. 'They think they're ancient evil? We have worse critics!' Rumi retorts.",
    origin: 'JINU',
    destination: 'KABUL',
    reward: 38500000,
    fanReward: 4650000,
    type: 'TOUR_DATE',
    buttonDescriptor: 'Start Tour Date'
  },
  {
    id: 'mission_dushanbe_dev',
    title: 'Dushanbe Dev Spirits',
    description: "Tajik Dev spirits are haunting Dushanbe. 'They need better choreography!' Mira critiques.",
    origin: 'FANS',
    destination: 'DUSHANBE',
    reward: 39500000,
    fanReward: 4750000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_tashkent_albasti',
    title: 'Tashkent Albasti Demons',
    description: "Uzbek Albasti demons are attacking Tashkent. 'Nobody disrupts our silk road concerts!' Mira vows.",
    origin: 'JINU',
    destination: 'TASHKENT',
    reward: 40000000,
    fanReward: 4800000,
    type: 'ENDORSEMENT',
    buttonDescriptor: 'Sign Endorsement Deal'
  },
  {
    id: 'mission_almaty_almasty',
    title: 'Almaty Almasty Wildman',
    description: "Kazakh Almasty wildmen are roaming Almaty. 'Another Bigfoot cousin? Fighting them all!' Zoey declares.",
    origin: 'FANS',
    destination: 'ALMATY',
    reward: 40500000,
    fanReward: 4850000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_novosibirsk_siberian_demon',
    title: 'Novosibirsk Siberian Demon',
    description: "Siberian ice demons are haunting Novosibirsk. 'Nobody disrupts our winter concerts!' Zoey defends.",
    origin: 'JINU',
    destination: 'NOVOSIBIRSK',
    reward: 41000000,
    fanReward: 4900000,
    type: 'TOUR_DATE',
    buttonDescriptor: 'Start Tour Date'
  },
  {
    id: 'mission_vladivostok_russian_demon',
    title: 'Vladivostok Russian Sea Demon',
    description: "Russian sea demons are threatening Vladivostok's port. 'Nobody disrupts our Pacific concerts!' Rumi insists.",
    origin: 'FANS',
    destination: 'VLADIVOSTOK',
    reward: 42000000,
    fanReward: 5000000,
    type: 'ENDORSEMENT',
    buttonDescriptor: 'Sign Endorsement Deal'
  },
  {
    id: 'mission_tripoli_jinn',
    title: 'Tripoli Desert Jinn',
    description: "Libyan desert Jinn are haunting Tripoli's ancient ruins. 'They need to respect Roman history and our tour!' Rumi declares.",
    origin: 'JINU',
    destination: 'TRIPOLI',
    reward: 19000000,
    fanReward: 2700000,
    type: 'TOUR_DATE',
    buttonDescriptor: 'Start Tour Date'
  },
  {
    id: 'mission_tunis_ghoul',
    title: 'Tunis Carthage Ghouls',
    description: "Ancient Carthage ghouls are haunting Tunis. 'They think they're ancient? Our music is timeless!' Zoey boasts.",
    origin: 'FANS',
    destination: 'TUNIS',
    reward: 18500000,
    fanReward: 2650000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_algiers_hna',
    title: 'Algiers H\'na Water Spirits',
    description: "Algerian H'na water spirits are haunting the Mediterranean coast. 'Nobody disrupts our beach concerts!' Mira defends.",
    origin: 'JINU',
    destination: 'ALGIERS',
    reward: 19500000,
    fanReward: 2750000,
    type: 'ENDORSEMENT',
    buttonDescriptor: 'Sign Endorsement Deal'
  },
  {
    id: 'mission_casablanca_aisha_kandisha',
    title: 'Casablanca Aisha Kandisha',
    description: "Moroccan Aisha Kandisha demon is seducing fans in Casablanca. 'She thinks she can charm our fans? Never!' Mira scoffs.",
    origin: 'FANS',
    destination: 'CASABLANCA',
    reward: 20000000,
    fanReward: 2800000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_marrakech_jinn',
    title: 'Marrakech Medina Jinn',
    description: "Moroccan Jinn are causing chaos in Marrakech's souks. 'Nobody ruins our spice shopping!' Rumi insists.",
    origin: 'JINU',
    destination: 'MARRAKECH',
    reward: 20500000,
    fanReward: 2850000,
    type: 'TOUR_DATE',
    buttonDescriptor: 'Start Tour Date'
  },
  {
    id: 'mission_dakar_yoo',
    title: 'Dakar Yoo Water Spirits',
    description: "Senegalese Yoo water spirits are haunting Dakar's coastline. 'Nobody disrupts our ocean concerts!' Zoey vows.",
    origin: 'FANS',
    destination: 'DAKAR',
    reward: 21000000,
    fanReward: 2900000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_abidjan_blou',
    title: 'Abidjan Blou Forest Spirits',
    description: "Ivorian Blou forest spirits are disrupting Abidjan. 'They need better dance moves!' Mira critiques.",
    origin: 'JINU',
    destination: 'ABIDJAN',
    reward: 21500000,
    fanReward: 2950000,
    type: 'ENDORSEMENT',
    buttonDescriptor: 'Sign Endorsement Deal'
  },
  {
    id: 'mission_accra_asanbosam',
    title: 'Accra Asanbosam Vampires',
    description: "Ghanaian Asanbosam vampires are haunting Accra's forests. 'They think they can fly? We have private jets!' Mira boasts.",
    origin: 'FANS',
    destination: 'ACCRA',
    reward: 22000000,
    fanReward: 3000000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_lome_mami_wata',
    title: 'Lomé Mami Wata',
    description: "Togolese Mami Wata mermaids are seducing fans in Lomé. 'She thinks she can compete with us? Please!' Rumi scoffs.",
    origin: 'JINU',
    destination: 'LOME',
    reward: 22500000,
    fanReward: 3050000,
    type: 'TOUR_DATE',
    buttonDescriptor: 'Start Tour Date'
  },
  {
    id: 'mission_khartoum_zar',
    title: 'Khartoum Zar Possession',
    description: "Sudanese Zar spirits are possessing people in Khartoum. 'They need to respect our fan meetups!' Rumi insists.",
    origin: 'FANS',
    destination: 'KHARTOUM',
    reward: 23000000,
    fanReward: 3100000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_addis_ababa_buda',
    title: 'Addis Ababa Buda Evil Eye',
    description: "Ethiopian Buda evil eye spirits are cursing fans in Addis Ababa. 'They think they can curse us? We have anti-fan hexes!' Zoey declares.",
    origin: 'JINU',
    destination: 'ADDIS_ABABA',
    reward: 23500000,
    fanReward: 3150000,
    type: 'ENDORSEMENT',
    buttonDescriptor: 'Sign Endorsement Deal'
  },
  {
    id: 'mission_nairobi_ogbanje',
    title: 'Nairobi Ogbanje Reincarnators',
    description: "Kenyan Ogbanje reincarnating spirits are causing chaos in Nairobi. 'They think they can come back? Our fame is eternal!' Mira boasts.",
    origin: 'FANS',
    destination: 'NAIROBI',
    reward: 24000000,
    fanReward: 3200000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_mogadishu_djinn',
    title: 'Mogadishu Somali Djinn',
    description: "Somali Djinn are haunting Mogadishu's port. 'Nobody disrupts our Indian Ocean concerts!' Mira defends.",
    origin: 'JINU',
    destination: 'MOGADISHU',
    reward: 24500000,
    fanReward: 3250000,
    type: 'TOUR_DATE',
    buttonDescriptor: 'Start Tour Date'
  },
  {
    id: 'mission_dar_es_salaam_popobawa',
    title: 'Dar es Salaam Popobawa',
    description: "Tanzanian Popobawa bat demon is terrorizing Dar es Salaam. 'They think they can scare us? We've seen worse antis!' Rumi retorts.",
    origin: 'FANS',
    destination: 'DAR_ES_SALAAM',
    reward: 25000000,
    fanReward: 3300000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_kampala_mayembe',
    title: 'Kampala Mayembe Tree Spirits',
    description: "Ugandan Mayembe tree spirits are haunting Kampala. 'Nobody disrupts our nature concerts!' Zoey vows.",
    origin: 'JINU',
    destination: 'KAMPALA',
    reward: 25500000,
    fanReward: 3350000,
    type: 'ENDORSEMENT',
    buttonDescriptor: 'Sign Endorsement Deal'
  },
  {
    id: 'mission_kigali_inkoko',
    title: 'Kigali Inkoko Chicken Demons',
    description: "Rwandan Inkoko chicken demons are terrorizing Kigali. 'They think they can out-peck us? Never!' Rumi scoffs.",
    origin: 'FANS',
    destination: 'KIGALI',
    reward: 26000000,
    fanReward: 3400000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_bujumbura_kirima',
    title: 'Bujumbura Kirima Mountain Spirits',
    description: "Burundian Kirima mountain spirits are haunting Bujumbura. 'Nobody disrupts our mountain retreats!' Mira insists.",
    origin: 'JINU',
    destination: 'BUJUMBURA',
    reward: 26500000,
    fanReward: 3450000,
    type: 'TOUR_DATE',
    buttonDescriptor: 'Start Tour Date'
  },
  {
    id: 'mission_kinshasa_mokole_mbembe',
    title: 'Kinshasa Mokélé-Mbembé',
    description: "Congolese Mokélé-Mbembé dinosaur demon is terrorizing Kinshasa. 'They brought back what? This is why we can't have nice things!' Mira complains.",
    origin: 'FANS',
    destination: 'KINSHASA',
    reward: 27000000,
    fanReward: 3500000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_luanda_kishi',
    title: 'Luanda Kishi Ghosts',
    description: "Angolan Kishi two-faced demons are haunting Luanda. 'They think they can deceive us? We see everything!' Rumi boasts.",
    origin: 'JINU',
    destination: 'LUANDA',
    reward: 27500000,
    fanReward: 3550000,
    type: 'ENDORSEMENT',
    buttonDescriptor: 'Sign Endorsement Deal'
  },
  {
    id: 'mission_windhoek_hai-uri',
    title: 'Windhoek Hai-Uri Giants',
    description: "Namibian Hai-Uri giants are roaming Windhoek. 'They think they're tall? Our stage presence is taller!' Zoey declares.",
    origin: 'FANS',
    destination: 'WINDHOEK',
    reward: 28000000,
    fanReward: 3600000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_gaborone_bogwera',
    title: 'Gaborone Bogwera Rain Demons',
    description: "Botswanan Bogwera rain demons are disrupting Gaborone. 'Nobody ruins our outdoor concerts!' Rumi vows.",
    origin: 'JINU',
    destination: 'GABORONE',
    reward: 28500000,
    fanReward: 3650000,
    type: 'TOUR_DATE',
    buttonDescriptor: 'Start Tour Date'
  },
  {
    id: 'mission_harare_tokoloshe',
    title: 'Harare Tokoloshe Goblins',
    description: "Zimbabwean Tokoloshe goblins are causing chaos in Harare. 'They think they can sneak? We see everything!' Mira scoffs.",
    origin: 'FANS',
    destination: 'HARARE',
    reward: 29000000,
    fanReward: 3700000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_lusaka_chimwemwe',
    title: 'Lusaka Chimwemwe Light Spirits',
    description: "Zambian Chimwemwe light spirits are haunting Lusaka. 'They think they're bright? Our stage lights are brighter!' Mira boasts.",
    origin: 'JINU',
    destination: 'LUSAKA',
    reward: 29500000,
    fanReward: 3750000,
    type: 'ENDORSEMENT',
    buttonDescriptor: 'Sign Endorsement Deal'
  },
  {
    id: 'mission_lilongwe_matsapa',
    title: 'Lilongwe Matsapa Water Spirits',
    description: "Malawian Matsapa water spirits are haunting Lilongwe. 'Nobody disrupts our lake concerts!' Zoey defends.",
    origin: 'FANS',
    destination: 'LILONGWE',
    reward: 30000000,
    fanReward: 3800000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_blantyre_nyamatsapa',
    title: 'Blantyre Nyamatsapa Crocodile Demons',
    description: "Malawian Nyamatsapa crocodile demons are terrorizing Blantyre. 'They think they can bite? We have better bites!' Rumi retorts.",
    origin: 'JINU',
    destination: 'BLANTYRE',
    reward: 30500000,
    fanReward: 3850000,
    type: 'TOUR_DATE',
    buttonDescriptor: 'Start Tour Date'
  },
  {
    id: 'mission_maputo_nhlapiri',
    title: 'Maputo Nhlapiri Shapeshifters',
    description: "Mozambican Nhlapiri shapeshifters are haunting Maputo. 'They think they can shapeshift? We have costume changes!' Rumi declares.",
    origin: 'FANS',
    destination: 'MAPUTO',
    reward: 31000000,
    fanReward: 3900000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_brazzaville_mokole_mbembe',
    title: 'Brazzaville Mokélé-Mbembé',
    description: "Congolese Mokélé-Mbembé dinosaur demon is terrorizing Brazzaville. 'Again with the dinosaurs? Really?' Mira complains.",
    origin: 'JINU',
    destination: 'BRAZZAVILLE',
    reward: 31500000,
    fanReward: 3950000,
    type: 'ENDORSEMENT',
    buttonDescriptor: 'Sign Endorsement Deal'
  },
  {
    id: 'mission_luxembourg_klepper',
    title: 'Luxembourg Klepper Trickster',
    description: "Luxembourgish Klepper trickster spirits are haunting the castle. 'They think they can out-trick us? Never!' Zoey scoffs.",
    origin: 'FANS',
    destination: 'LUXEMBOURG',
    reward: 19000000,
    fanReward: 2700000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_brussels_schiffer',
    title: 'Brussels Schiffer Water Spirits',
    description: "Belgian Schiffer water spirits are haunting Brussels canals. 'Nobody disrupts our chocolate tours!' Rumi insists.",
    origin: 'JINU',
    destination: 'BRUSSELS',
    reward: 19500000,
    fanReward: 2750000,
    type: 'ENDORSEMENT',
    buttonDescriptor: 'Sign Endorsement Deal'
  },
  {
    id: 'mission_amsterdam_witte_wieven',
    title: 'Amsterdam Witte Wieven',
    description: "Dutch Witte Wieven white women are haunting Amsterdam. 'They think they can out-spell us? We have better magic!' Mira boasts.",
    origin: 'FANS',
    destination: 'AMSTERDAM',
    reward: 20000000,
    fanReward: 2800000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_frankfurt_wolpertinger',
    title: 'Frankfurt Wolpertinger',
    description: "German Wolpertinger winged creatures are terrorizing Frankfurt. 'They think they can fly? We have private jets!' Mira declares.",
    origin: 'JINU',
    destination: 'FRANKFURT',
    reward: 20500000,
    fanReward: 2850000,
    type: 'TOUR_DATE',
    buttonDescriptor: 'Start Tour Date'
  },
  {
    id: 'mission_zurich_alp_demon',
    title: 'Zurich Alpine Demon',
    description: "Swiss Alpine demons are haunting the Swiss mountains. 'Nobody disrupts our mountain concerts!' Rumi vows.",
    origin: 'FANS',
    destination: 'ZURICH',
    reward: 21000000,
    fanReward: 2900000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_milan_basilisk',
    title: 'Milan Basilisk',
    description: "Italian Basilisk is terrorizing Milan's fashion district. 'They think they can out-style us? Please!' Zoey scoffs.",
    origin: 'JINU',
    destination: 'MILAN',
    reward: 21500000,
    fanReward: 2950000,
    type: 'ENDORSEMENT',
    buttonDescriptor: 'Sign Endorsement Deal'
  },
  {
    id: 'mission_oslo_troll',
    title: 'Oslo Forest Troll',
    description: "Norwegian forest trolls are blocking Oslo's streets. 'Nobody disrupts our fjord concerts!' Rumi defends.",
    origin: 'FANS',
    destination: 'OSLO',
    reward: 22000000,
    fanReward: 3000000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_copenhagen_havfrue',
    title: 'Copenhagen Havfrue Mermaids',
    description: "Danish Havfrue mermaids are seducing fans in Copenhagen. 'She thinks she can compete with us? Never!' Mira retorts.",
    origin: 'JINU',
    destination: 'COPENHAGEN',
    reward: 22500000,
    fanReward: 3050000,
    type: 'TOUR_DATE',
    buttonDescriptor: 'Start Tour Date'
  },
  {
    id: 'mission_tallinn_kratt',
    title: 'Tallinn Kratt Goblins',
    description: "Estonian Kratt goblins are haunting Tallinn. 'They think they can out-work us? We have better work ethic!' Mira insists.",
    origin: 'FANS',
    destination: 'TALLINN',
    reward: 23000000,
    fanReward: 3100000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_riga_vadakojis',
    title: 'Riga Vadāķis Dragons',
    description: "Latvian Vadāķis dragons are flying over Riga. 'They think they can out-fly us? We have helicopters!' Zoey boasts.",
    origin: 'JINU',
    destination: 'RIGA',
    reward: 23500000,
    fanReward: 3150000,
    type: 'ENDORSEMENT',
    buttonDescriptor: 'Sign Endorsement Deal'
  },
  {
    id: 'mission_vilnius_aitvaras',
    title: 'Vilnius Aitvaras Serpent',
    description: "Lithuanian Aitvaras fire serpents are terrorizing Vilnius. 'Nobody disrupts our amber shopping!' Rumi declares.",
    origin: 'FANS',
    destination: 'VILNIUS',
    reward: 24000000,
    fanReward: 3200000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_reykjavik_yule_lads',
    title: 'Reykjavik Yule Lads',
    description: "Icelandic Yule Lads are causing mischief in Reykjavik. 'They think they can out-prank us? We invented pranks!' Rumi scoffs.",
    origin: 'JINU',
    destination: 'REYKJAVIK',
    reward: 24500000,
    fanReward: 3250000,
    type: 'TOUR_DATE',
    buttonDescriptor: 'Start Tour Date'
  },
  {
    id: 'mission_dublin_leprechaun',
    title: 'Dublin Leprechaun Gold',
    description: "Irish leprechauns are hiding gold in Dublin. 'They think they can out-greed us? We have better deals!' Mira boasts.",
    origin: 'FANS',
    destination: 'DUBLIN',
    reward: 25000000,
    fanReward: 3300000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_nicosia_kalikantzaroi',
    title: 'Nicosia Kalikantzaroi Goblins',
    description: "Cypriot Kalikantzaroi goblins are haunting Nicosia. 'Nobody disrupts our Mediterranean concerts!' Zoey vows.",
    origin: 'JINU',
    destination: 'NICOSIA',
    reward: 25500000,
    fanReward: 3350000,
    type: 'ENDORSEMENT',
    buttonDescriptor: 'Sign Endorsement Deal'
  },
  {
    id: 'mission_tel_aviv_demon',
    title: 'Tel Aviv Demon Attack',
    description: "Israeli demons are terrorizing Tel Aviv. 'Nobody disrupts our beach parties!' Mira defends.",
    origin: 'FANS',
    destination: 'TEL_AVIV',
    reward: 26000000,
    fanReward: 3400000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_beirut_marid',
    title: 'Beirut Marid Sea Spirits',
    description: "Lebanese Marid sea spirits are haunting Beirut's coast. 'Nobody disrupts our Mediterranean cruises!' Rumi insists.",
    origin: 'JINU',
    destination: 'BEIRUT',
    reward: 26500000,
    fanReward: 3450000,
    type: 'TOUR_DATE',
    buttonDescriptor: 'Start Tour Date'
  },
  {
    id: 'mission_damascus_ghoul',
    title: 'Damascus Ancient Ghouls',
    description: "Syrian ghouls are haunting Damascus's old city. 'They need to respect ancient history and our tour!' Rumi declares.",
    origin: 'FANS',
    destination: 'DAMASCUS',
    reward: 27000000,
    fanReward: 3500000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_amman_jinn',
    title: 'Amman Desert Jinn',
    description: "Jordanian desert Jinn are haunting Amman. 'Nobody disrupts our desert concerts!' Mira defends.",
    origin: 'JINU',
    destination: 'AMMAN',
    reward: 27500000,
    fanReward: 3550000,
    type: 'ENDORSEMENT',
    buttonDescriptor: 'Sign Endorsement Deal'
  },
  {
    id: 'mission_colombo_raksha',
    title: 'Colombo Raksha Demons',
    description: "Sri Lankan Raksha demons are protecting Colombo. 'They think they can protect better than us? Never!' Zoey scoffs.",
    origin: 'FANS',
    destination: 'COLOMBO',
    reward: 28000000,
    fanReward: 3600000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_male_fann',
    title: 'Malé Fann Sea Demons',
    description: "Maldivian Fann sea demons are haunting Malé. 'Nobody disrupts our island paradise!' Rumi vows.",
    origin: 'JINU',
    destination: 'MALE',
    reward: 28500000,
    fanReward: 3650000,
    type: 'TOUR_DATE',
    buttonDescriptor: 'Start Tour Date'
  },
  {
    id: 'mission_thimphu_migoi',
    title: 'Thimphu Migoi Yeti',
    description: "Bhutanese Migoi yeti are roaming Thimphu. 'Another Yeti cousin? Fighting them all!' Zoey declares.",
    origin: 'FANS',
    destination: 'THIMPHU',
    reward: 29000000,
    fanReward: 3700000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_chennai_pey',
    title: 'Chennai Pey Demons',
    description: "Tamil Pey demons are haunting Chennai. 'They think they can out-dance us? Never!' Mira boasts.",
    origin: 'JINU',
    destination: 'CHENNAI',
    reward: 29500000,
    fanReward: 3750000,
    type: 'ENDORSEMENT',
    buttonDescriptor: 'Sign Endorsement Deal'
  },
  {
    id: 'mission_bangalore_naga',
    title: 'Bangalore Naga Serpents',
    description: "Kannada Naga serpents are terrorizing Bangalore. 'Nobody disrupts our tech hub concerts!' Zoey defends.",
    origin: 'FANS',
    destination: 'BANGALORE',
    reward: 30000000,
    fanReward: 3800000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_port_louis_demon',
    title: 'Port Louis Demon Attack',
    description: "Mauritian demons are haunting Port Louis. 'Nobody disrupts our island paradise!' Rumi insists.",
    origin: 'JINU',
    destination: 'PORT_LOUIS',
    reward: 30500000,
    fanReward: 3850000,
    type: 'TOUR_DATE',
    buttonDescriptor: 'Start Tour Date'
  },
  {
    id: 'mission_antananarivo_kalanoro',
    title: 'Antananarivo Kalanoro',
    description: "Malagasy Kalanoro ogres are terrorizing Antananarivo. 'They think they can out-eat us? Never!' Mira scoffs.",
    origin: 'FANS',
    destination: 'ANTANANARIVO',
    reward: 31000000,
    fanReward: 3900000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_georgetown_kanaima',
    title: 'Georgetown Kanaima Spirit',
    description: "Guyanese Kanaima spirits are haunting Georgetown. 'Nobody disrupts our jungle concerts!' Rumi vows.",
    origin: 'JINU',
    destination: 'GEORGETOWN',
    reward: 31500000,
    fanReward: 3950000,
    type: 'ENDORSEMENT',
    buttonDescriptor: 'Sign Endorsement Deal'
  },
  {
    id: 'mission_paramaribo_ayahuasca',
    title: 'Paramaribo Ayahuasca Spirits',
    description: "Surinamese Ayahuasca spirits are disrupting Paramaribo. 'Nobody disrupts our spiritual journeys!' Zoey insists.",
    origin: 'FANS',
    destination: 'PARAMARIBO',
    reward: 32000000,
    fanReward: 4000000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_port_of_spain_douen',
    title: 'Port of Spain Douen',
    description: "Trinidadian Douen faceless children are haunting Port of Spain. 'They think they can scare us? We've seen worse antis!' Rumi retorts.",
    origin: 'JINU',
    destination: 'PORT_OF_SPAIN',
    reward: 32500000,
    fanReward: 4050000,
    type: 'TOUR_DATE',
    buttonDescriptor: 'Start Tour Date'
  },
  {
    id: 'mission_santo_domingo_bacá',
    title: 'Santo Domingo Bacá Spirits',
    description: "Dominican Bacá spirits are haunting Santo Domingo. 'Nobody disrupts our Caribbean concerts!' Mira declares.",
    origin: 'FANS',
    destination: 'SANTO_DOMINGO',
    reward: 33000000,
    fanReward: 4100000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_san_juan_chupacabra',
    title: 'San Juan Chupacabra',
    description: "Puerto Rican Chupacabra is terrorizing San Juan. 'Nobody disrupts our tropical concerts!' Mira defends.",
    origin: 'JINU',
    destination: 'SAN_JUAN',
    reward: 33500000,
    fanReward: 4150000,
    type: 'ENDORSEMENT',
    buttonDescriptor: 'Sign Endorsement Deal'
  },
  {
    id: 'mission_montevideo_lobizon',
    title: 'Montevideo Lobizon Werewolf',
    description: "Uruguayan Lobizon werewolf is terrorizing Montevideo. 'They think they can out-howl us? We have microphones!' Zoey boasts.",
    origin: 'FANS',
    destination: 'MONTEVIDEO',
    reward: 34000000,
    fanReward: 4200000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_asuncion_pombero',
    title: 'Asunción Pombero',
    description: "Paraguayan Pombero stalker demon is haunting Asunción. 'Nobody disrupts our jungle concerts!' Rumi vows.",
    origin: 'JINU',
    destination: 'ASUNCION',
    reward: 34500000,
    fanReward: 4250000,
    type: 'TOUR_DATE',
    buttonDescriptor: 'Start Tour Date'
  },
  {
    id: 'mission_la_paz_ahuizotl',
    title: 'La Paz Ahuizotl Water Dog',
    description: "Bolivian Ahuizotl water dog demon is terrorizing La Paz. 'Nobody disrupts our mountain concerts!' Mira insists.",
    origin: 'FANS',
    destination: 'LA_PAZ',
    reward: 35000000,
    fanReward: 4300000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_santiago_culebron',
    title: 'Santiago Culebrón Serpent',
    description: "Chilean Culebrón winged serpent is terrorizing Santiago. 'They think they can out-fly us? We have helicopters!' Mira boasts.",
    origin: 'JINU',
    destination: 'SANTIAGO',
    reward: 35500000,
    fanReward: 4350000,
    type: 'ENDORSEMENT',
    buttonDescriptor: 'Sign Endorsement Deal'
  },
  {
    id: 'mission_quito_tunda',
    title: 'Quito Tunda Demon',
    description: "Ecuadorian Tunda one-legged demon is haunting Quito. 'They think they can out-hop us? Never!' Zoey scoffs.",
    origin: 'FANS',
    destination: 'QUITO',
    reward: 36000000,
    fanReward: 4400000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_san_jose_cadejos',
    title: 'San José Cadejos Dogs',
    description: "Costa Rican Cadejos dual dogs are protecting San José. 'They think they can guard better than us? Please!' Rumi retorts.",
    origin: 'JINU',
    destination: 'SAN_JOSE',
    reward: 36500000,
    fanReward: 4450000,
    type: 'TOUR_DATE',
    buttonDescriptor: 'Start Tour Date'
  },
  {
    id: 'mission_belmopan_sisimito',
    title: 'Belmopan Sisimito Demons',
    description: "Belizean Sisimito demons are haunting Belmopan. 'Nobody disrupts our rainforest concerts!' Rumi declares.",
    origin: 'FANS',
    destination: 'BELMOPAN',
    reward: 37000000,
    fanReward: 4500000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_ashgabat_dev',
    title: 'Ashgabat Turkmen Dev',
    description: "Turkmen Dev demons are haunting Ashgabat. 'Nobody disrupts our desert concerts!' Mira vows.",
    origin: 'JINU',
    destination: 'ASHGABAT',
    reward: 37500000,
    fanReward: 4550000,
    type: 'ENDORSEMENT',
    buttonDescriptor: 'Sign Endorsement Deal'
  },
  {
    id: 'mission_ulaanbaatar_almas',
    title: 'Ulaanbaatar Almas Wildman',
    description: "Mongolian Almas wildmen are roaming Ulaanbaatar. 'Another Bigfoot cousin? Fighting them all!' Zoey declares.",
    origin: 'FANS',
    destination: 'ULAANBAATAR',
    reward: 38000000,
    fanReward: 4600000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_irkutsk_chud',
    title: 'Irkutsk Chud Spirits',
    description: "Siberian Chud spirits are haunting Irkutsk. 'Nobody disrupts our Siberian concerts!' Zoey defends.",
    origin: 'JINU',
    destination: 'IRKUTSK',
    reward: 38500000,
    fanReward: 4650000,
    type: 'TOUR_DATE',
    buttonDescriptor: 'Start Tour Date'
  },
  {
    id: 'mission_yerevan_vishap',
    title: 'Yerevan Vishap Dragons',
    description: "Armenian Vishap dragons are terrorizing Yerevan. 'They think they can out-breathe fire? We have better stage effects!' Rumi boasts.",
    origin: 'FANS',
    destination: 'YEREVAN',
    reward: 39000000,
    fanReward: 4700000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_tbilisi_ali',
    title: 'Tbilisi Ali Demons',
    description: "Georgian Ali demons are haunting Tbilisi. 'Nobody disrupts our Caucasian concerts!' Mira insists.",
    origin: 'JINU',
    destination: 'TBILISI',
    reward: 39500000,
    fanReward: 4750000,
    type: 'ENDORSEMENT',
    buttonDescriptor: 'Sign Endorsement Deal'
  },
  {
    id: 'mission_skopje_karagioz',
    title: 'Skopje Karagioz Demons',
    description: "Macedonian Karagioz shadow demons are haunting Skopje. 'They think they can out-shadow us? We have better lighting!' Zoey scoffs.",
    origin: 'FANS',
    destination: 'SKOPJE',
    reward: 40000000,
    fanReward: 4800000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_ljubljana_kurent',
    title: 'Ljubljana Kurent',
    description: "Slovenian Kurent carnival demons are haunting Ljubljana. 'Nobody disrupts our winter festivals!' Rumi vows.",
    origin: 'JINU',
    destination: 'LJUBLJANA',
    reward: 40500000,
    fanReward: 4850000,
    type: 'TOUR_DATE',
    buttonDescriptor: 'Start Tour Date'
  },
  {
    id: 'mission_zagreb_krsnik',
    title: 'Zagreb Krsnik Vampire Hunter',
    description: "Croatian Krsnik vampire hunters are confusing Zagreb. 'They think we're vampires? We're demon hunters!' Mira clarifies.",
    origin: 'FANS',
    destination: 'ZAGREB',
    reward: 41000000,
    fanReward: 4900000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_suva_tevo',
    title: 'Suva Tevo Demons',
    description: "Fijian Tevo demons are haunting Suva. 'Nobody disrupts our Pacific paradise!' Rumi declares.",
    origin: 'JINU',
    destination: 'SUVA',
    reward: 41500000,
    fanReward: 4950000,
    type: 'ENDORSEMENT',
    buttonDescriptor: 'Sign Endorsement Deal'
  },
  {
    id: 'mission_port_moresby_dokona',
    title: 'Port Moresby Dokona',
    description: "Papua New Guinean Dokona witches are haunting Port Moresby. 'They think they can out-spell us? We have better magic!' Zoey boasts.",
    origin: 'FANS',
    destination: 'PORT_MORESBY',
    reward: 42000000,
    fanReward: 5000000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_nadi_vakalele',
    title: 'Nadi Vakalele Demons',
    description: "Fijian Vakalele demons are terrorizing Nadi. 'Nobody disrupts our island concerts!' Rumi defends.",
    origin: 'JINU',
    destination: 'NADI',
    reward: 42500000,
    fanReward: 5050000,
    type: 'TOUR_DATE',
    buttonDescriptor: 'Start Tour Date'
  },
  {
    id: 'mission_honiara_adaro',
    title: 'Honiara Adaro Sea Spirit',
    description: "Solomon Islands Adaro sea spirits are haunting Honiara. 'Nobody disrupts our ocean concerts!' Mira vows.",
    origin: 'FANS',
    destination: 'HONIARA',
    reward: 43000000,
    fanReward: 5100000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_macau_jiangshi',
    title: 'Macau Jiangshi Vampires',
    description: "Chinese Jiangshi hopping vampires are haunting Macau's casinos. 'They think they can out-hop us? We have better dance moves!' Zoey scoffs.",
    origin: 'JINU',
    destination: 'MACAU',
    reward: 43500000,
    fanReward: 5150000,
    type: 'ENDORSEMENT',
    buttonDescriptor: 'Sign Endorsement Deal'
  },
  {
    id: 'mission_malta_karkkannon',
    title: 'Malta Karkkannon Demons',
    description: "Maltese Karkkannon demons are haunting Valletta. 'Nobody disrupts our Mediterranean concerts!' Rumi insists.",
    origin: 'FANS',
    destination: 'MALTA',
    reward: 44000000,
    fanReward: 5200000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_samarkand_div',
    title: 'Samarkand Persian Div',
    description: "Persian Div demons are haunting Samarkand's ancient city. 'They need to respect history and our tour!' Rumi declares.",
    origin: 'JINU',
    destination: 'SAMARKAND',
    reward: 44500000,
    fanReward: 5250000,
    type: 'TOUR_DATE',
    buttonDescriptor: 'Start Tour Date'
  },
  {
    id: 'mission_bukhara_jinn',
    title: 'Bukhara Desert Jinn',
    description: "Uzbek desert Jinn are haunting Bukhara. 'Nobody disrupts our Silk Road concerts!' Mira defends.",
    origin: 'FANS',
    destination: 'BUKHARA',
    reward: 45000000,
    fanReward: 5300000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_taipei_huli_jing',
    title: 'Taipei Huli Jing Fox Spirits',
    description: "Taiwanese Huli Jing fox spirits are seducing fans in Taipei. 'She thinks she can charm our fans? Never!' Zoey boasts.",
    origin: 'JINU',
    destination: 'TAIPEI',
    reward: 45500000,
    fanReward: 5350000,
    type: 'ENDORSEMENT',
    buttonDescriptor: 'Sign Endorsement Deal'
  },
  {
    id: 'mission_moldova_strigoi',
    title: 'Moldova Strigoi Vampires',
    description: "Moldovan Strigoi vampires are haunting Chișinău. 'They think they're immortal? Our fame is eternal!' Rumi declares.",
    origin: 'FANS',
    destination: 'CHISINAU',
    reward: 46000000,
    fanReward: 5400000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_sarajevo_drekavac',
    title: 'Sarajevo Drekavac Screamer',
    description: "Bosnian Drekavac screamers are haunting Sarajevo. 'They think they can out-scream us? We have microphones!' Mira scoffs.",
    origin: 'JINU',
    destination: 'SARAJEVO',
    reward: 46500000,
    fanReward: 5450000,
    type: 'TOUR_DATE',
    buttonDescriptor: 'Start Tour Date'
  },
  {
    id: 'mission_podgorica_vila',
    title: 'Podgorica Vila Fairies',
    description: "Montenegrin Vila fairies are haunting Podgorica. 'They think they can out-fly us? We have helicopters!' Zoey boasts.",
    origin: 'FANS',
    destination: 'PODGORICA',
    reward: 47000000,
    fanReward: 5500000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_tirana_kukudhi',
    title: 'Tirana Kukudhi Spirits',
    description: "Albanian Kukudhi spirits are haunting Tirana. 'Nobody disrupts our Balkan concerts!' Rumi vows.",
    origin: 'JINU',
    destination: 'TIRANA',
    reward: 47500000,
    fanReward: 5550000,
    type: 'ENDORSEMENT',
    buttonDescriptor: 'Sign Endorsement Deal'
  },
  {
    id: 'mission_pristina_dracula',
    title: 'Pristina Dracula Vampire',
    description: "Kosovan Dracula is terrorizing Pristina. 'They think they're the original vampire? We fight better ones!' Mira retorts.",
    origin: 'FANS',
    destination: 'PRISTINA',
    reward: 48000000,
    fanReward: 5600000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_abuja_ogbanje',
    title: 'Abuja Ogbanje Reincarnators',
    description: "Nigerian Ogbanje reincarnating spirits are causing chaos in Abuja. 'They think they can come back? Our fame is eternal!' Mira insists.",
    origin: 'JINU',
    destination: 'ABUJA',
    reward: 48500000,
    fanReward: 5650000,
    type: 'TOUR_DATE',
    buttonDescriptor: 'Start Tour Date'
  },
  {
    id: 'mission_niamey_zin',
    title: 'Niamey Zin Water Spirits',
    description: "Nigerien Zin water spirits are haunting Niamey. 'Nobody disrupts our Niger River concerts!' Zoey defends.",
    origin: 'FANS',
    destination: 'NIAMEY',
    reward: 49000000,
    fanReward: 5700000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_qatar_ghoul',
    title: 'Doha Desert Ghoul',
    description: "Qatari desert ghouls are haunting Doha. 'Nobody disrupts our desert concerts!' Mira vows.",
    origin: 'JINU',
    destination: 'DOHA',
    reward: 49500000,
    fanReward: 5750000,
    type: 'ENDORSEMENT',
    buttonDescriptor: 'Sign Endorsement Deal'
  },
  {
    id: 'mission_bahrain_jinn',
    title: 'Manama Pearl Jinn',
    description: "Bahraini pearl Jinn are haunting Manama's oyster beds. 'Nobody disrupts our pearl diving concerts!' Rumi insists.",
    origin: 'FANS',
    destination: 'MANAMA',
    reward: 50000000,
    fanReward: 5800000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_oman_ifrit',
    title: 'Muscat Ifrit Fire Demon',
    description: "Omani Ifrit fire demons are terrorizing Muscat. 'They think they can out-burn us? We have better stage effects!' Zoey boasts.",
    origin: 'JINU',
    destination: 'MUSCAT',
    reward: 50500000,
    fanReward: 5850000,
    type: 'TOUR_DATE',
    buttonDescriptor: 'Start Tour Date'
  },
  {
    id: 'mission_cambodia_apsara',
    title: 'Phnom Penh Apsara Spirits',
    description: "Cambodian Apsara spirits are haunting Angkor Wat. 'They think they can out-dance us? Never!' Mira scoffs.",
    origin: 'FANS',
    destination: 'PHNOM_PENH',
    reward: 51000000,
    fanReward: 5900000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_laos_phi',
    title: 'Vientiane Phi Spirits',
    description: "Laotian Phi spirits are haunting Vientiane. 'Nobody disrupts our Mekong River concerts!' Rumi declares.",
    origin: 'JINU',
    destination: 'VIENTIANE',
    reward: 51500000,
    fanReward: 5950000,
    type: 'ENDORSEMENT',
    buttonDescriptor: 'Sign Endorsement Deal'
  },
  {
    id: 'mission_tajikistan_dev',
    title: 'Dushanbe Tajik Dev',
    description: "Tajik Dev demons are haunting Dushanbe. 'Nobody disrupts our mountain concerts!' Mira defends.",
    origin: 'FANS',
    destination: 'DUSHANBE',
    reward: 52000000,
    fanReward: 6000000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_kyrgyzstan_alp_karyst',
    title: 'Bishkek Alp Karyst Giants',
    description: "Kyrgyz Alp Karyst giants are roaming Bishkek. 'They think they're tall? Our stage presence is taller!' Rumi boasts.",
    origin: 'JINU',
    destination: 'BISHKEK',
    reward: 52500000,
    fanReward: 6050000,
    type: 'TOUR_DATE',
    buttonDescriptor: 'Start Tour Date'
  },
  {
    id: 'mission_turkmenistan_jinn',
    title: 'Ashgabat Turkmen Jinn',
    description: "Turkmen desert Jinn are haunting Ashgabat. 'Nobody disrupts our Silk Road concerts!' Zoey insists.",
    origin: 'FANS',
    destination: 'ASHGABAT',
    reward: 53000000,
    fanReward: 6100000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_russia_baba_yaga',
    title: 'Moscow Baba Yaga',
    description: "Russian Baba Yaga is terrorizing Moscow. 'She thinks she can out-fly us? We have helicopters!' Mira retorts.",
    origin: 'JINU',
    destination: 'MOSCOW',
    reward: 53500000,
    fanReward: 6150000,
    type: 'ENDORSEMENT',
    buttonDescriptor: 'Sign Endorsement Deal'
  },
  {
    id: 'mission_belarus_vodyanoy',
    title: 'Minsk Vodyanoy Water Spirit',
    description: "Belarusian Vodyanoy water spirits are haunting Minsk. 'Nobody disrupts our lake concerts!' Mira vows.",
    origin: 'FANS',
    destination: 'MINSK',
    reward: 54000000,
    fanReward: 6200000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_ukraine_mavka',
    title: 'Kiev Mavka Forest Spirit',
    description: "Ukrainian Mavka forest spirits are haunting Kiev. 'They think they can out-charm us? Never!' Zoey scoffs.",
    origin: 'JINU',
    destination: 'KIEV',
    reward: 54500000,
    fanReward: 6250000,
    type: 'TOUR_DATE',
    buttonDescriptor: 'Start Tour Date'
  },
  {
    id: 'mission_morocco_ghoul',
    title: 'Casablanca Ghouls',
    description: "Moroccan ghouls are haunting Casablanca. 'Nobody disrupts our Moroccan spice markets!' Rumi defends.",
    origin: 'FANS',
    destination: 'CASABLANCA',
    reward: 55000000,
    fanReward: 6300000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_libya_jinn',
    title: 'Tripoli Desert Jinn',
    description: "Libyan desert Jinn are haunting Tripoli. 'Nobody disrupts our ancient Roman ruins!' Rumi declares.",
    origin: 'JINU',
    destination: 'TRIPOLI',
    reward: 55500000,
    fanReward: 6350000,
    type: 'ENDORSEMENT',
    buttonDescriptor: 'Sign Endorsement Deal'
  },
  {
    id: 'mission_algeria_ifrit',
    title: 'Algiers Ifrit Fire Demon',
    description: "Algerian Ifrit fire demons are terrorizing Algiers. 'They think they can out-burn us? We have pyrotechnics!' Mira boasts.",
    origin: 'FANS',
    destination: 'ALGIERS',
    reward: 56000000,
    fanReward: 6400000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_egypt_anubis',
    title: 'Cairo Anubis Guardians',
    description: "Egyptian Anubis guardians are protecting the pyramids. 'They think they can guard better than us? Please!' Mira scoffs.",
    origin: 'JINU',
    destination: 'CAIRO',
    reward: 56500000,
    fanReward: 6450000,
    type: 'TOUR_DATE',
    buttonDescriptor: 'Start Tour Date'
  },
  {
    id: 'mission_uganda_kikongo',
    title: 'Kampala Kikongo Demons',
    description: "Ugandan Kikongo demons are haunting Kampala. 'Nobody disrupts our Lake Victoria concerts!' Zoey insists.",
    origin: 'FANS',
    destination: 'KAMPALA',
    reward: 57000000,
    fanReward: 6500000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_zambia_chimwemwe',
    title: 'Lusaka Chimwemwe Light Spirits',
    description: "Zambian Chimwemwe light spirits are illuminating Lusaka. 'They think they can out-shine us? We have better lighting!' Rumi retorts.",
    origin: 'JINU',
    destination: 'LUSAKA',
    reward: 57500000,
    fanReward: 6550000,
    type: 'ENDORSEMENT',
    buttonDescriptor: 'Sign Endorsement Deal'
  },
  {
    id: 'mission_kenya_ogbanje',
    title: 'Nairobi Ogbanje Reincarnators',
    description: "Kenyan Ogbanje reincarnators are causing chaos in Nairobi. 'They think they can come back? Our fame is eternal!' Mira vows.",
    origin: 'FANS',
    destination: 'NAIROBI',
    reward: 58000000,
    fanReward: 6600000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_argentina_mapinguari',
    title: 'Buenos Aires Mapinguari',
    description: "Argentinian Mapinguari giant sloth demon is terrorizing Buenos Aires. 'They think they can out-slow us? We have better rhythm!' Zoey boasts.",
    origin: 'JINU',
    destination: 'BUENOS_AIRES',
    reward: 58500000,
    fanReward: 6650000,
    type: 'TOUR_DATE',
    buttonDescriptor: 'Start Tour Date'
  },
  {
    id: 'mission_venezuela_chupacabra',
    title: 'Caracas Chupacabra',
    description: "Venezuelan Chupacabra is terrorizing Caracas. 'Nobody disrupts our Caribbean concerts!' Mira defends.",
    origin: 'FANS',
    destination: 'CARACAS',
    reward: 59000000,
    fanReward: 6700000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_jamaica_duppy',
    title: 'Kingston Duppy Spirits',
    description: "Jamaican Duppy spirits are haunting Kingston. 'Nobody disrupts our reggae concerts!' Rumi insists.",
    origin: 'JINU',
    destination: 'KINGSTON',
    reward: 59500000,
    fanReward: 6750000,
    type: 'ENDORSEMENT',
    buttonDescriptor: 'Sign Endorsement Deal'
  },
  {
    id: 'mission_bahamas_lusca',
    title: 'Nassau Lusca Sea Monster',
    description: "Bahamian Lusca sea monsters are haunting Nassau. 'Nobody disrupts our island paradise!' Rumi declares.",
    origin: 'FANS',
    destination: 'NASSAU',
    reward: 60000000,
    fanReward: 6800000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_barbados_chickcharney',
    title: 'Bridgetown Chickcharney',
    description: "Barbadian Chickcharney owls are haunting Bridgetown. 'They think they can out-fly us? We have jets!' Zoey scoffs.",
    origin: 'JINU',
    destination: 'BARBADOS',
    reward: 60500000,
    fanReward: 6850000,
    type: 'TOUR_DATE',
    buttonDescriptor: 'Start Tour Date'
  },
  {
    id: 'mission_anguilla_jumbie',
    title: 'The Valley Jumbie Spirits',
    description: "Anguillan Jumbie spirits are haunting The Valley. 'Nobody disrupts our Caribbean concerts!' Mira vows.",
    origin: 'FANS',
    destination: 'ANGUILLA',
    reward: 61000000,
    fanReward: 6900000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_bermuda_moongazer',
    title: 'Hamilton Moongazer',
    description: "Bermudian Moongazer is haunting Hamilton. 'Nobody disrupts our Triangle concerts!' Rumi insists.",
    origin: 'JINU',
    destination: 'BERMUDA',
    reward: 61500000,
    fanReward: 6950000,
    type: 'ENDORSEMENT',
    buttonDescriptor: 'Sign Endorsement Deal'
  },
  {
    id: 'mission_cayman_duppy',
    title: 'George Town Duppy',
    description: "Caymanian Duppy spirits are haunting George Town. 'Nobody disrupts our island concerts!' Zoey defends.",
    origin: 'FANS',
    destination: 'CAYMAN_ISLANDS',
    reward: 62000000,
    fanReward: 7000000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_bvi_jumbie',
    title: 'Road Town Jumbie',
    description: "British Virgin Islands Jumbie spirits are haunting Road Town. 'Nobody disrupts our pirate concerts!' Mira boasts.",
    origin: 'JINU',
    destination: 'BRITISH_VIRGIN_ISLANDS',
    reward: 62500000,
    fanReward: 7050000,
    type: 'TOUR_DATE',
    buttonDescriptor: 'Start Tour Date'
  },
  {
    id: 'mission_seychelles_jinn',
    title: 'Victoria Seychelles Jinn',
    description: "Seychellois Jinn are haunting Victoria. 'Nobody disrupts our island paradise!' Mira vows.",
    origin: 'FANS',
    destination: 'SEYCHELLES',
    reward: 63000000,
    fanReward: 7100000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_grenada_lusca',
    title: 'St. George\'s Lusca',
    description: "Grenadian Lusca sea monsters are haunting St. George's. 'Nobody disrupts our Spice Island concerts!' Rumi insists.",
    origin: 'JINU',
    destination: 'GRENADA',
    reward: 63500000,
    fanReward: 7150000,
    type: 'ENDORSEMENT',
    buttonDescriptor: 'Sign Endorsement Deal'
  },
  {
    id: 'mission_yemen_jinn',
    title: 'Sana Yemeni Jinn',
    description: "Yemeni Jinn are haunting Sana. 'Nobody disrupts our ancient city concerts!' Rumi declares.",
    origin: 'FANS',
    destination: 'YEMEN',
    reward: 64000000,
    fanReward: 7200000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_namibia_hai_uri',
    title: 'Windhoek Hai-Uri Giants',
    description: "Namibian Hai-Uri giants are roaming Windhoek. 'They think they're tall? Our stage presence is taller!' Zoey boasts.",
    origin: 'JINU',
    destination: 'NAMIBIA',
    reward: 64500000,
    fanReward: 7250000,
    type: 'TOUR_DATE',
    buttonDescriptor: 'Start Tour Date'
  },
  {
    id: 'mission_mozambique_nhlapiri',
    title: 'Maputo Nhlapiri Shapeshifters',
    description: "Mozambican Nhlapiri shapeshifters are haunting Maputo. 'Nobody disrupts our Indian Ocean concerts!' Mira defends.",
    origin: 'FANS',
    destination: 'MOZAMBIQUE',
    reward: 65000000,
    fanReward: 7300000,
    type: 'COLLAB',
    buttonDescriptor: 'Host Secret Fan Meet'
  },
  {
    id: 'mission_micronesia_nahual',
    title: 'Palikir Nahual Spirits',
    description: "Micronesian Nahual spirits are haunting Palikir. 'Nobody disrupts our Pacific island concerts!' Mira vows.",
    origin: 'JINU',
    destination: 'MICRONESIA',
    reward: 65500000,
    fanReward: 7350000,
    type: 'ENDORSEMENT',
    buttonDescriptor: 'Sign Endorsement Deal'
  },
];
